// Inline SVG glyphs for each compliance module, carried from the original
// propertyactions.co.uk module cards. stroke=currentColor so they take the tile colour.

import type { ReactElement } from "react";

type IconKey = "fire" | "asbestos" | "eicr" | "water" | "gas" | "lift" | "pack";

const PATHS: Record<IconKey, ReactElement> = {
  fire: (
    <path d="M12 3c1.5 2 2 3.7 1.4 5.2C15.8 7.8 18 9.7 18 13a6 6 0 1 1-12 0c0-2.7 1.7-4.8 4-6.7-.2 2.1.4 3.6 2 4.7" />
  ),
  asbestos: (
    <>
      <path d="M12 2v20M4 6h16M5 18h14" />
      <path d="M8 6c0 5 8 7 8 12" />
    </>
  ),
  eicr: <path d="m13 2-8 13h7l-1 7 8-13h-7z" />,
  water: <path d="M12 2s7 7 7 12a7 7 0 1 1-14 0c0-5 7-12 7-12z" />,
  gas: (
    <>
      <path d="M12 3c3 4 5 7 5 10a5 5 0 1 1-10 0c0-3 2-6 5-10z" />
      <path d="M9 16h6" />
    </>
  ),
  lift: (
    <>
      <path d="M6 3h12v18H6z" />
      <path d="m9 10 3-3 3 3M15 14l-3 3-3-3" />
    </>
  ),
  pack: (
    <>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <path d="m3.3 7 8.7 5 8.7-5M12 22V12" />
    </>
  ),
};

export function ModuleIcon({ k, className = "h-5 w-5" }: { k: IconKey; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {PATHS[k]}
    </svg>
  );
}

export function Check({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.7} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export function Arrow({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  );
}
